import { Component, ElementRef, ViewChild, ChangeDetectorRef, NgZone } from "@angular/core";
import { AppService } from "src/app/app.service";
import { ChatbotService } from "./../chatbot/chatbot.service";
import { Router, NavigationEnd } from "@angular/router";
import { ExportToExcelService } from "src/app/shared/services/export-to-excel.service";
import { PassScenarioService } from "./../../../shared/services/pass-scenario.service";
import { perCapitaData } from "../../ubc/my-scenario/baseline-contract-details/baseline-contract-constants";
import { ScenarioRefreshService } from "./bot.service";
import { CommonDateService } from "src/app/shared/services/common-date.service";
import { marked } from "marked";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// import { MyScenarioService } from "src/app/modules/ubc/my-scenario/my-scenario.service";

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrl: './bot.component.scss'
})
export class BotComponent {
  @ViewChild("chatWindow") chatWindow!: ElementRef;
  @ViewChild("chatContainer") chatContainerRef?: ElementRef<HTMLElement>;

  // The input lives behind *ngIf="isOpen && showChatbot", so it doesn't exist yet the one time
  // ngAfterViewInit fires (chat starts closed) and gets torn down/recreated every time the chat
  // is closed/reopened -- a plain @ViewChild only captures whichever instance existed when
  // Angular last checked views, so it'd go stale. The setter form re-attaches (and detaches from
  // the old element) every time Angular assigns a new reference, including the first time the
  // panel actually opens.
  private _projectNameInputRef?: ElementRef<HTMLInputElement>;
  @ViewChild("projectNameInput")
  set projectNameInputRef(ref: ElementRef<HTMLInputElement> | undefined) {
    const previousEl = this._projectNameInputRef?.nativeElement;
    if (previousEl) {
      previousEl.removeEventListener('input', this.onRawInput);
      previousEl.removeEventListener('keydown', this.onRawKeydown);
    }
    this._projectNameInputRef = ref;
    const el = ref?.nativeElement;
    if (el) {
      this.ngZone.runOutsideAngular(() => {
        el.addEventListener('input', this.onRawInput);
        el.addEventListener('keydown', this.onRawKeydown);
      });
    }
  }
  get projectNameInputRef(): ElementRef<HTMLInputElement> | undefined {
    return this._projectNameInputRef;
  }

  scenarioId: number;
  messages: any[] = [];
  userInput = "";
  step = 0;
  currentIntent = "";
  tempData: any = {};
  showInput = false;
  isLoading: boolean = false;
  loaderBgType: string;
  fixedLoader: boolean = false;
  validationError = '';
  newScId: number;
  chatHistory: any[] = [];
  perCapData: any;
  isOpen = false; // Controls if chatbot is open or just the icon is shown
  isMinimized = false;
  // position = { top: 100, left: 100 }; // Default position
  private isDragging = false;
  private dragOffset = { x: 0, y: 0 };
  private fabElementForDrag: HTMLElement | null = null;
  refreshme: boolean = false; // Used to refresh the component when needed

  showScenarioModal = false;
  scenarioList: any[] = []; // [{name: string, id: number, selected: boolean}]
  pagedScenarios: any[] = [];
  allScenarios: any[] = [];
  scenarioSearch: string = '';
  selectAllChecked = false;
  currentPage = 1;
  totalPages = 1;
  pageSize = 10;
  modalAction: 'refresh' | 'delete' | 'export' | 'duplicate' = 'refresh';
  allProjectNames: string[] = [];
  projectNameSuggestion: string = '';
  filteredProjectNames: string[] = [];
  showDropdown = false;
  private keydownListener: (() => void) | null = null;
  isThinking: boolean = false;
  showConfirmModal = false;
  pendingAction: 'delete' | 'refresh' | null = null;
  position = { left: null, top: null };
  private wasDragged = false;
  private fabDragStart = { x: 0, y: 0 };
  private static readonly DRAG_THRESHOLD_PX = 5;
  selectedChatbotFlow: 'rule' | 'genai' = 'genai';
  sessionId: string | null = null;
  selectedGenAiSubFlow: 'websearch' | 'generic' | null = null;
  ruleMessages: any[] = [];
  genaiMessages: any[] = [];
  private brandChannelOptions: { channels: string[]; brands: { brand: string; therapyArea: string }[] } | null = null;
  readonly feedbackRatings = [1, 2, 3, 4, 5];


  constructor(
    private chatbotService: ChatbotService,
    private appService: AppService,
    private exportToExcelService: ExportToExcelService,
    private passScenario: PassScenarioService,
    // public myScenarioService: MyScenarioService,
    // public MyScenarioComponent: MyScenarioComponent,
    private route: Router,
    private scenarioRefreshService: ScenarioRefreshService,
    private cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private dateService: CommonDateService
  ) { }

  ngOnInit() {
    // Load saved chat data first
    this.loadChatFromSession();

    // Only add welcome messages if there are no existing messages for the selected flow
    // if (this.selectedChatbotFlow === 'genai' && this.genaiMessages.length === 0 && this.messages.length === 0) {
    //   this.addBotMessage("Welcome to CDS Assistant! Ask me anything for creative dynamic calculations.");
    //   this.step = 1;
    // } else if (this.selectedChatbotFlow === 'rule' && this.ruleMessages.length === 0 && this.messages.length === 0) {
    //   this.addBotMessage("What would you like to do next?", ["Duplicate Scenario", "Export Scenario Data", "Create Scenario", "Delete Scenario", "Refresh Scenario"]);
    //   this.step = 0;
    // }

    // Set the correct step for the current flow
    if (this.selectedChatbotFlow === 'genai') {
      this.step = 1;
    } else if (this.selectedChatbotFlow === 'rule') {
      this.step = 0;
    }

    this.fetchAllProjectNames();

    this.scenarioRefreshService.scenarioRefreshed$.subscribe((scenarioId: number) => {
      this.addBotMessage(`Scenario ${scenarioId} refreshed!`);
      this.cdRef.detectChanges();
    });

    this.scenarioRefreshService.refreshComplete$.subscribe(() => {
      this.isThinking = false;
      this.cdRef.detectChanges();
      this.resetChat2();
    });

    window.addEventListener('resize', this.onWindowResize);
     this.initSessionId();
     this.loadChatFromSession();
  }

  // The chat text box used to be bound with [(ngModel)], which -- like every Angular-bound DOM
  // listener -- fires inside Angular's zone. zone.js schedules a full ApplicationRef.tick() after
  // every zone task, and a tick walks the ENTIRE app component tree, not just this one -- so
  // every keystroke here was also re-running change detection across whatever heavy page (e.g.
  // the scenario view, whose templates call several methods directly in *ngIf/{{}} bindings)
  // happened to be open behind the chat widget. The projectNameInputRef setter above attaches
  // these two listeners outside the zone instead; each only calls this component's own
  // detectChanges(), which keeps typing here from touching the rest of the app.
  private onRawInput = (event: Event) => {
    const value = (event.target as HTMLInputElement).value;
    this.userInput = value;
    this.onInputChange(value);
    this.cdRef.detectChanges();
  };

  private onRawKeydown = (event: KeyboardEvent) => {
    if ((event.key === 'Tab' || event.key === 'Enter') && this.projectNameSuggestion) {
      event.preventDefault();
      this.userInput = this.userInput + this.projectNameSuggestion;
      this.projectNameSuggestion = '';
      if (this.projectNameInputRef) {
        this.projectNameInputRef.nativeElement.value = this.userInput;
      }
    }
    if (event.key === 'Enter' && this.isValidFormat()) {
      event.preventDefault();
      // Sending is a one-shot action (unlike per-keystroke typing) that needs the zone anyway --
      // it kicks off HTTP calls whose callbacks must run inside Angular for their own UI updates
      // (isThinking, addBotMessage, etc.) to take effect.
      this.ngZone.run(() => this.handleUserInput());
      return;
    }
    this.cdRef.detectChanges();
  };

  private readonly STORAGE_KEYS = {
    RULE_MESSAGES: 'chatbot_rule_messages',
    GENAI_MESSAGES: 'chatbot_genai_messages',
    SELECTED_FLOW: 'chatbot_selected_flow',
    SELECTED_GENAI_SUBFLOW: 'chatbot_selected_genai_subflow',
    SESSION_ID: 'chatbot_session_id',
    TIMESTAMP: 'chatbot_timestamp'
  };

  private generateSessionId(): string {
  return 'sess_' + Date.now() + '_' + Math.random().toString(36).substring(2);
  }

  private initSessionId() {
  const storedSessionId = sessionStorage.getItem(this.STORAGE_KEYS.SESSION_ID);

  if (storedSessionId) {
    this.sessionId = storedSessionId;
  } else {
    this.sessionId = this.generateSessionId();
    sessionStorage.setItem(this.STORAGE_KEYS.SESSION_ID, this.sessionId);
  }
  }

  private readonly EXPIRY_TIME = 30 * 60 * 1000;

  private saveChatToSession() {
  try {
    const timestamp = Date.now();
    
    // IMPORTANT: Update flow-specific arrays with current messages before saving
    if (this.selectedChatbotFlow === 'rule') {
      this.ruleMessages = [...this.messages];
    } else if (this.selectedChatbotFlow === 'genai') {
      this.genaiMessages = [...this.messages];
    }
    
    sessionStorage.setItem(this.STORAGE_KEYS.RULE_MESSAGES, JSON.stringify(this.ruleMessages));
    sessionStorage.setItem(this.STORAGE_KEYS.GENAI_MESSAGES, JSON.stringify(this.genaiMessages));
    sessionStorage.setItem(this.STORAGE_KEYS.SELECTED_FLOW, this.selectedChatbotFlow);
    sessionStorage.setItem(this.STORAGE_KEYS.SELECTED_GENAI_SUBFLOW, this.selectedGenAiSubFlow || '');
    sessionStorage.setItem(this.STORAGE_KEYS.SESSION_ID, this.sessionId);
    sessionStorage.setItem(this.STORAGE_KEYS.TIMESTAMP, timestamp.toString());
  } catch (error) {
    console.warn('Failed to save chat data to session storage:', error);
  }
}

private normalizeMessages(messages: any[]) {
  return messages.map(m => {
    const text =
      typeof m.text === 'string'
        ? m.text
        : JSON.stringify(m.text ?? '');

    return {
      ...m,
      text,
      feedback: m.feedback ? { ...m.feedback, open: false, saving: false, error: '' } : undefined,
      safeHtml: this.sanitizer.bypassSecurityTrustHtml(
        marked.parse(text, { async: false }) as string
      )
    };
  });
}

// Update the loadChatFromSession method
private loadChatFromSession() {
  try {
    // Check if data has expired
    const timestamp = sessionStorage.getItem(this.STORAGE_KEYS.TIMESTAMP);
    if (timestamp) {
      const savedTime = parseInt(timestamp);
      const currentTime = Date.now();
      const timeDiff = currentTime - savedTime;
      
      if (timeDiff > this.EXPIRY_TIME) {
        console.log('Chat data expired after 30 minutes, clearing session storage');
        this.clearChatFromSession();
        return;
      }
    }

    const ruleMessages = sessionStorage.getItem(this.STORAGE_KEYS.RULE_MESSAGES);
    const genaiMessages = sessionStorage.getItem(this.STORAGE_KEYS.GENAI_MESSAGES);
    const selectedFlow = sessionStorage.getItem(this.STORAGE_KEYS.SELECTED_FLOW);
    const selectedGenaiSubFlow = sessionStorage.getItem(this.STORAGE_KEYS.SELECTED_GENAI_SUBFLOW);
    const sessionId = sessionStorage.getItem(this.STORAGE_KEYS.SESSION_ID);

    // Load messages arrays first
    if (ruleMessages) {
    this.ruleMessages = this.normalizeMessages(JSON.parse(ruleMessages));
    }
    if (genaiMessages) {
      this.genaiMessages = this.normalizeMessages(JSON.parse(genaiMessages));
    }
    
    // Only override default flow if there's a saved flow AND it has messages
    if (selectedFlow && (selectedFlow === 'rule' || selectedFlow === 'genai')) {
      const hasRuleMessages = this.ruleMessages.length > 0;
      const hasGenaiMessages = this.genaiMessages.length > 0;
      
      // Only change from default 'genai' if there are actual saved messages for the saved flow
      if ((selectedFlow === 'rule' && hasRuleMessages) || (selectedFlow === 'genai' && hasGenaiMessages)) {
        this.selectedChatbotFlow = selectedFlow as 'rule' | 'genai';
      }
    }
    
    if (selectedGenaiSubFlow) {
      this.selectedGenAiSubFlow = selectedGenaiSubFlow as 'websearch' | 'generic' | null;
    }
    if (sessionId) {
      this.sessionId = sessionId;
    }

    // Restore messages for the selected flow AFTER all properties are set
    if (this.selectedChatbotFlow === 'rule' && this.ruleMessages.length > 0) {
      this.messages = [...this.ruleMessages];
    } else if (this.selectedChatbotFlow === 'genai' && this.genaiMessages.length > 0) {
      this.messages = [...this.genaiMessages];
    }

    if (Array.isArray(this.messages)) {
  this.messages = this.messages.map(m => {
    const text = typeof m.text === 'string'
      ? m.text
      : JSON.stringify(m.text ?? '');

    return {
      ...m,
      text,
      safeHtml: this.sanitizer.bypassSecurityTrustHtml(
        marked.parse(text, { async: false }) as string
      )
    };
  });
}
    
  } catch (error) {
    console.warn('Failed to load chat data from session storage:', error);
  }
}

selectChatbotFlow(flow: 'rule' | 'genai') {
  // Save current messages to appropriate history before switching
  if (this.selectedChatbotFlow === 'rule') {
    this.ruleMessages = [...this.messages];
  } else if (this.selectedChatbotFlow === 'genai') {
    this.genaiMessages = [...this.messages];
  }

  this.selectedChatbotFlow = flow;

  if (flow === 'rule') {
    if (this.ruleMessages.length === 0) {
      this.messages = []; // Clear first
      this.addBotMessage("What would you like to do next?", ["Duplicate Scenario", "Export Scenario Data", "Delete Scenario", "Refresh Scenario"]);
    } else {
      this.messages = [...this.ruleMessages];
    }
    this.step = 0; // Rule-based starts at step 0
  } else if (flow === 'genai') {
    if (this.genaiMessages.length === 0) {
      this.messages = []; // Clear first
      this.addBotMessage("Welcome to Gen AI Based Flow! Ask me anything for creative dynamic calculations.");
    } else {
      this.messages = [...this.genaiMessages];
    }
    this.step = 1; // Gen AI starts at step 1
  }
  
  // Save after switching
  this.saveChatToSession();
}
  // Clear chat data from session storage
  private clearChatFromSession() {
    try {
      Object.values(this.STORAGE_KEYS).forEach(key => {
        sessionStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('Failed to clear chat data from session storage:', error);
    }
  }
  
  selectGenAiSubFlow(flow: 'websearch' | 'generic') {
    if (this.selectedGenAiSubFlow === flow) {
      // Deselect if already selected
      this.selectedGenAiSubFlow = null;
    } else {
      // Select the clicked flow
      this.selectedGenAiSubFlow = flow;
    }

    
  }

  fetchAllProjectNames() {
    this.chatbotService.getAllProjectNames().subscribe((data) => {
      if (data.success && Array.isArray(data.data)) {
        this.allProjectNames = data.data;
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Create Scenario quick form
  //
  // Replaces the old question-at-a-time chain (step 1 -> 2/20 -> 21 -> 22 -> 5 -> 6 -> 7 -> 8),
  // which cost 6 turns for an existing project and 8 for a new one - and charged a whole extra
  // round trip for something as small as a mistyped date. The same two paths are still modelled
  // here, just as conditional fields on one card instead of as states in a machine.
  // ---------------------------------------------------------------------------

  createForm: any = this.blankCreateForm();
  createFormBrands: { brand: string; therapyArea: string }[] = [];
  createFormChannels: string[] = [];
  createFormPayers: string[] = [];
  createFormErrors: { [key: string]: string } = {};
  createFormLoadingPayers = false;
  createFormSubmitting = false;
  createFormDone = false;

  private blankCreateForm() {
    return {
      isNewProject: false,
      projectName: '',
      product: '',
      channel: '',
      therapyArea: null,
      scenarioName: '',
      contractStartDate: '',
      contractEndDate: '',
      payer: ''
    };
  }

  /** Entry point: post the form as a chat card and warm up the option lists. */
  startCreateScenarioForm() {
    this.createForm = this.blankCreateForm();
    this.createFormErrors = {};
    this.createFormPayers = [];
    this.createFormDone = false;
    this.createFormSubmitting = false;
    // The previous card's picker element is gone once it freezes into its summary; drop the
    // reference so the setter re-initialises bounds for the new one.
    this.csDateRangeEl = null;

    if (!this.allProjectNames?.length) {
      this.fetchAllProjectNames();
    }
    this.fetchBrandChannelOptions().subscribe(({ brands, channels }) => {
      this.createFormBrands = brands || [];
      this.createFormChannels = channels || [];
    });

    this.showInput = false; // the card collects everything; the text box would be noise
    this.addBotMessage(
      "Let's create a scenario. Fill in the details below.",
      undefined,
      undefined,
      'createScenarioForm'
    );
    // resetChat2() keeps the transcript, so a second run would otherwise re-bind the earlier
    // card to the same (now blank) createForm and make it look editable again. Hold onto this
    // message so it can be frozen with its own snapshot once submitted.
    this.activeCreateFormMessage = this.messages[this.messages.length - 1];
  }

  private activeCreateFormMessage: any = null;

  // Contract period uses the same zsui month-range picker as the Create Scenario screen. That
  // screen drives its bounds off the backend `Dates` timeline, which the bot has no reason to
  // fetch, so the bounds are set to a plain calendar window instead - the picker itself only
  // needs 'MM-YYYY' strings.
  private csDateRangeEl: any = null;

  @ViewChild('csDateRange') set csDateRangeSetter(ref: ElementRef<any> | undefined) {
    const el = ref?.nativeElement;
    if (!el || el === this.csDateRangeEl) return;
    this.csDateRangeEl = el;
    const thisYear = new Date().getFullYear();
    el.minRange = `01-${thisYear - 1}`;
    el.maxRange = `12-${thisYear + 5}`;
  }

  onCreateFormDateChange() {
    const el = this.csDateRangeEl;
    if (!el || !el.startRange || !el.endRange) return;

    // Same conversion the Create Scenario screen performs: the range is month-granular, so the
    // contract runs from the first day of the start month to the last day of the end month.
    const period = this.dateService.getContractStartEndInDateFormat(el.startRange, el.endRange);
    this.createForm.contractStartDate = this.toIsoDate(period.ContractStartDate);
    this.createForm.contractEndDate = this.toIsoDate(period.ContractEndDate);
    delete this.createFormErrors.contractPeriod;
  }

  /**
   * Formats from the local calendar fields rather than toISOString(), which converts to UTC -
   * for any timezone ahead of UTC the local midnight the picker produces would roll back to the
   * previous day, silently shifting the contract period by one day.
   */
  private toIsoDate(d: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  /** True while an unsubmitted form card is on screen. */
  get isCreateFormOpen(): boolean {
    return !!this.activeCreateFormMessage && !this.activeCreateFormMessage.submitted;
  }

  /** Short enough not to be clipped by the select, and says what is actually blocking. */
  get payerPlaceholder(): string {
    if (this.createFormLoadingPayers) return 'Loading payers…';
    if (this.createFormPayers.length) return 'Select a payer';
    return this.createForm.isNewProject ? 'Pick brand & channel first' : 'Pick a project first';
  }

  /** Abandons the form and hands the menu back, rather than stranding the user in it. */
  cancelCreateScenarioForm() {
    if (this.createFormSubmitting) return;
    if (this.activeCreateFormMessage) {
      // Drop the card entirely; a cancelled form is not a useful thing to keep in the transcript.
      const idx = this.messages.indexOf(this.activeCreateFormMessage);
      if (idx > -1) this.messages.splice(idx, 1);
      this.activeCreateFormMessage = null;
    }
    this.csDateRangeEl = null;
    this.createFormErrors = {};
    this.resetChat2();
  }

  /** Switching between the new/existing project paths resets what the other path filled in. */
  onCreateFormPathChange() {
    this.createForm.projectName = '';
    this.createForm.product = '';
    this.createForm.channel = '';
    this.createForm.therapyArea = null;
    this.createForm.payer = '';
    this.createFormPayers = [];
    this.createFormErrors = {};
  }

  /** Existing-project path: pull product/channel off the project instead of asking for them. */
  onCreateFormProjectSelected() {
    const projectName = (this.createForm.projectName || '').trim();
    this.createForm.product = '';
    this.createForm.channel = '';
    this.createForm.payer = '';
    this.createFormPayers = [];
    if (!projectName) return;

    this.chatbotService.getProjectDetails({ projectName }).subscribe({
      next: (detailsData) => {
        if (detailsData.success && detailsData.data.length > 0) {
          const projectRow = detailsData.data[0];
          this.createForm.product = projectRow.BrandName;
          this.createForm.channel = projectRow.Channel;
          this.loadCreateFormPayers();
        } else {
          this.createFormErrors.projectName = 'Could not read details for this project.';
        }
      },
      error: () => {
        this.createFormErrors.projectName = 'Could not look up this project.';
      }
    });
  }

  /** New-project path: therapy area is a fixed 1:1 off the brand, so it is never asked for. */
  onCreateFormBrandChange() {
    const matched = this.createFormBrands.find(
      (b) => b.brand.toLowerCase() === (this.createForm.product || '').toLowerCase()
    );
    this.createForm.therapyArea = matched ? matched.therapyArea : null;
    this.loadCreateFormPayers();
  }

  onCreateFormChannelChange() {
    this.loadCreateFormPayers();
  }

  /** Payers depend on product + channel, so this reruns whenever either lands. */
  private loadCreateFormPayers() {
    const { projectName, product, channel, isNewProject, therapyArea } = this.createForm;
    if (!product || !channel) return;

    // On the new-project path the project does not exist yet, so it cannot be looked up to
    // resolve a therapy area - send the one derived from the brand instead. The endpoint only
    // ever used projectName to get at that value.
    const params: any = isNewProject
      ? { product, channel, therapyArea: therapyArea ?? '' }
      : { projectName, product, channel };

    this.createFormLoadingPayers = true;
    this.createForm.payer = '';
    this.chatbotService.getPayerOptions(params).subscribe({
      next: (data) => {
        this.createFormLoadingPayers = false;
        this.createFormPayers = data.success && Array.isArray(data.data) ? data.data : [];
      },
      error: () => {
        this.createFormLoadingPayers = false;
        this.createFormPayers = [];
      }
    });
  }

  private validateCreateForm(): boolean {
    const f = this.createForm;
    const errors: { [key: string]: string } = {};

    if (!f.projectName?.trim()) errors.projectName = 'Project name is required.';
    if (f.isNewProject) {
      if (!f.product?.trim()) errors.product = 'Brand/product is required.';
      if (!f.channel?.trim()) errors.channel = 'Channel is required.';
    }
    if (!f.scenarioName?.trim()) errors.scenarioName = 'Scenario name is required.';
    if (!f.contractStartDate || !f.contractEndDate) {
      errors.contractPeriod = 'Contract period is required.';
    } else if (f.contractEndDate < f.contractStartDate) {
      errors.contractPeriod = 'Contract period must end on or after it starts.';
    }
    if (!f.payer?.trim()) errors.payer = 'Payer is required.';

    this.createFormErrors = errors;
    return Object.keys(errors).length === 0;
  }

  submitCreateScenarioForm() {
    if (this.createFormSubmitting) return;
    if (!this.validateCreateForm()) return;

    const f = this.createForm;
    this.createFormSubmitting = true;

    // Name collisions were previously a wasted turn; check before doing any creating.
    this.chatbotService
      .checkScenarioName({ projectName: f.projectName.trim(), scenarioName: f.scenarioName.trim() })
      .subscribe({
        next: (data) => {
          if (data.success && data.data.length > 0) {
            this.createFormSubmitting = false;
            this.createFormErrors.scenarioName =
              'A scenario with this name already exists in this project.';
            return;
          }
          this.runCreateScenarioForm();
        },
        error: () => {
          this.createFormSubmitting = false;
          this.createFormErrors.scenarioName = 'Could not verify the scenario name.';
        }
      });
  }

  /** Creates the project first when on the new-project path, then the scenario. */
  private runCreateScenarioForm() {
    const f = this.createForm;

    // createEnrichedScenario() reads from tempData and already handles the slow-response case
    // where the pipeline outlives the HTTP request, so feed it rather than duplicating that.
    this.tempData = {
      projectName: f.projectName.trim(),
      scenarioName: f.scenarioName.trim(),
      product: f.product,
      channel: f.channel,
      payer: f.payer,
      contractStartDate: f.contractStartDate,
      contractEndDate: f.contractEndDate
    };

    this.createFormDone = true;
    // Freeze this card with its own copy of the values so it stays a correct record of what was
    // submitted, independent of any later run of the form.
    if (this.activeCreateFormMessage) {
      this.activeCreateFormMessage.submitted = true;
      this.activeCreateFormMessage.summary = {
        path: f.isNewProject ? 'New project' : 'Existing project',
        projectName: f.projectName,
        product: f.product,
        channel: f.channel,
        scenarioName: f.scenarioName,
        contractStartDate: f.contractStartDate,
        contractEndDate: f.contractEndDate,
        payer: f.payer
      };
    }
    this.showInput = false;
    this.isThinking = true;
    this.loaderBgType = this.appService.loaderColors.pine_green;
    this.fixedLoader = true;

    this.addUserMessage(
      `${f.isNewProject ? 'New' : 'Existing'} project "${f.projectName}" - scenario "${f.scenarioName}", ` +
      `${f.product} / ${f.channel}, ${f.payer}, ${f.contractStartDate} to ${f.contractEndDate}`
    );

    if (!f.isNewProject) {
      this.createEnrichedScenario();
      return;
    }

    const projectParams = {
      ProjectName: f.projectName.trim(),
      BrandName: f.product,
      Channel: f.channel,
      ChannelGroup: f.channel,
      IsBookmarked: false,
      CreatedBy: this.appService.loggedInUser?.name || 'CDS_BOT',
      ModifiedBy: this.appService.loggedInUser?.name || 'CDS_BOT',
      Notes: '',
      IsActive: 'Y',
      ProductFamilyFlag: 'Product',
      TherapyArea: f.therapyArea,
      Team: 'UBC'
    };

    this.chatbotService.createProject(projectParams).subscribe({
      next: (data) => {
        if (data && data.success !== false) {
          this.addBotMessage(`Project "${f.projectName}" created.`);
          this.createEnrichedScenario();
        } else {
          this.isThinking = false;
          this.fixedLoader = false;
          this.createFormSubmitting = false;
          this.createFormDone = false;
          this.addBotMessage('Could not create the project. Please contact the administrator.');
        }
      },
      error: () => {
        this.isThinking = false;
        this.fixedLoader = false;
        this.createFormSubmitting = false;
        this.createFormDone = false;
        this.addBotMessage('An error occurred creating the project. Please contact the administrator.');
      }
    });
  }

  get showChatbot(): boolean {
    return this.appService.loggedInUser?.team === 'UBC';
  }

  get IsGenaiChatbotEnabledd(): boolean {
    return this.appService.resources.IsGenaiChatbotEnabled?.Visible === 'Y';
  }

  get chatbotDisclaimerText(): string {
    return this.appService.resourceFields?.ChatbotDisclaimerText?.text?.trim()
      || 'Outputs are AI-generated and may be inaccurate. Independently verify before use.';
  }

private toSafeHtml(raw: string): SafeHtml {
  const normalized = String(raw ?? '')
    .replace(/\\n/g, '\n')
    .replace(/\\\\n/g, '\n')
    .replace(/\r/g, '\n');
  const html = marked.parse(normalized) as string;
  return this.sanitizer.bypassSecurityTrustHtml(html);
}

addBotMessage(
  text: string,
  options?: string[],
  html?: string,
  type?: string,
  feedbackSessionId?: string
) {
  const raw = text || '';
  const parsedHtml = marked.parse(raw, { async: false }) as string;

  const safeHtml = this.sanitizer.bypassSecurityTrustHtml(parsedHtml);

  this.messages.push({
    sender: 'bot',
    text : raw,
    safeHtml,
    options,
    html,
    type,
    ...(type === 'aiResponse' ? {
      responseId: 'response_' + Array.from(window.crypto.getRandomValues(new Uint8Array(16)))
        .map(value => value.toString(16).padStart(2, '0')).join(''),
      feedbackSessionId,
      feedback: { rating: null, comment: '', savedRating: null, savedComment: '', open: false, saving: false, saved: false, error: '' }
    } : {})
  });

  this.scrollToBottom();
  this.showInput = false;

  if (this.selectedChatbotFlow) {
    setTimeout(() => this.saveChatToSession(), 0);
  }
}

  toggleResponseFeedback(message: any) {
    message.feedback.open = !message.feedback.open;
  }

  feedbackChanged(message: any) {
    message.feedback.error = '';
    this.saveChatToSession();
  }

  isFeedbackUnchanged(message: any): boolean {
    const feedback = message.feedback;
    return feedback.saved && feedback.rating === feedback.savedRating && feedback.comment === feedback.savedComment;
  }

  submitResponseFeedback(message: any) {
    const feedback = message.feedback;
    if (!feedback || feedback.saving || this.isFeedbackUnchanged(message)) return;
    if (!Number.isInteger(feedback.rating) || feedback.rating < 1 || feedback.rating > 5) {
      feedback.error = 'Select a rating from 1 to 5.';
      return;
    }
    if (typeof feedback.comment !== 'string' || feedback.comment.length > 2000) {
      feedback.error = 'Comment must be at most 2000 characters.';
      return;
    }
    if (!message.feedbackSessionId || !message.responseId) {
      feedback.error = 'This answer cannot be rated. Please ask your question again.';
      return;
    }
    const params = {
      sessionId: message.feedbackSessionId,
      responseId: message.responseId,
      rating: feedback.rating,
      comment: feedback.comment || null
    };
    feedback.saving = true;
    feedback.error = '';
    this.chatbotService.saveResponseFeedback(params).subscribe({
      next: (result) => {
        feedback.saving = false;
        if (result?.success) {
          feedback.saved = true;
          feedback.savedRating = params.rating;
          feedback.savedComment = params.comment || '';
        } else {
          feedback.error = 'Could not save feedback. Please try again.';
        }
        this.saveChatToSession();
      },
      error: () => {
        feedback.saving = false;
        feedback.error = 'Could not save feedback. Please try again.';
        this.saveChatToSession();
      }
    });
  }


  addUserMessage(text: string) {
    this.messages.push({ sender: "user", text });
    this.scrollToBottom();

    // Save to session storage after adding message
    if (this.selectedChatbotFlow) {
      setTimeout(() => this.saveChatToSession(), 0);
    }
  }


  private static readonly TOP_LEVEL_MENU_OPTIONS = [
    'Duplicate Scenario', 'Export Scenario Data', 'Delete Scenario', 'Refresh Scenario'
  ];

  handleOptionClick(option: string) {
    // Any option chip that isn't one of the top-level menu actions (e.g. a suggested payer
    // name, or any future free-text-replacement chip) is just a clickable shortcut for typing
    // that exact text -- route it through the normal input pipeline instead of duplicating its
    // step-handling logic here.
    if (!BotComponent.TOP_LEVEL_MENU_OPTIONS.includes(option)) {
      this.userInput = option;
      this.handleUserInput();
      return;
    }

    this.addUserMessage(option);
    this.currentIntent = option.toLowerCase();

    if (option === 'Duplicate Scenario') {
      this.step = 1;
      this.addBotMessage("Please enter project name to duplicate scenario");
      this.showInput = true;
    } else if (option === 'Export Scenario Data') {
      this.validationError = '';
      this.step = 1;
      this.addBotMessage("Please enter project name to export scenario(s)");
      // this.addBotMessage('Export functionality coming soon.');
    } else if (option === 'Delete Scenario') {
      this.step = 1;
      this.addBotMessage("Please enter project name to delete scenario(s)");
      this.showInput = true;
    } else if (option === 'Create Scenario') {
      this.validationError = '';
      this.tempData = {};
      this.step = 1;
      // Collected on one conditional card now instead of 6-8 chat turns.
      this.startCreateScenarioForm();
    }
    else if (option === 'Refresh Scenario') {
      this.step = 1;
      this.addBotMessage("Please enter project name to refresh scenario(s)");
      this.showInput = true;
    }
  }
  handleUserInput() {
    const input = this.userInput.trim();
    if (!input) return;

    this.addUserMessage(input);
    this.showDropdown = false; // Hide the dropdown when sending

    if (this.currentIntent === 'delete scenario' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenario would you like to delete in ${projectName}?`);
              this.tempData.projectName = projectName;

              this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
                if (data.success && data.data.length > 0) {
      
                  const scenarios = data.data.map(s => ({
                    ScenarioID: s.ScenarioID,
                    projectID: s.ProjectID,
                    ModifiedBy: s.ModifiedBy,
                    ScenarioName: s.ScenarioName,
                    ParentType: s.ParentType
                  }));
                  this.openScenarioModal(scenarios,'delete'); // Reuse the modal
                } else {
                  this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                  this.step = 1;
                }
              });
            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      } 
    }

    if (this.currentIntent === 'duplicate scenario' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenario would you like to duplicate in ${projectName}?`);
              this.tempData.projectName = projectName;
              this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
                if (data.success && data.data.length > 0) {
      
                  const scenarios = data.data.filter(s => s.ParentType === 'Singleton')
                    .map(s => ({
                      ScenarioID: s.ScenarioID,
                      projectID: s.ProjectID,
                      ModifiedBy: s.ModifiedBy,
                      ScenarioName: s.ScenarioName,
                      ParentType: s.ParentType
                    }));
                  this.openScenarioModal(scenarios,'duplicate'); // Reuse the modal
                } else {
                  this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                  this.step = 1;
                }
              });
              // this.step = 2;
            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      } else if (this.step === 2) {
        const scenarioName = input.trim();

        // if (!scenario || !project) {
        //   this.validationError = 'Please enter in format (Case Sensitive): scenarioName, projectName';
        //   return;
        // }

        this.tempData.projectScenarioName = scenarioName;
        this.step = 2;
        this.validationError = ''; // Clear any existing error
        this.showInput = true;
        const param = {
          scenarioName: scenarioName,
          projectName: this.tempData.projectName
        }
        // 13760
        // mm,Rx MultiBrand
        this.chatbotService.checkScenarioName(param).subscribe((data) => {
          // console.log(data);
          if (data.success) {
            if (data.data.length > 0) {
              this.tempData.scenarioId = data.data[0].ScenarioID;
              this.addBotMessage(`Please enter the name for the duplicated scenario`);
              this.step = 3;
              // console.log(this.scenarioId);
            } else {
              this.addBotMessage("No scenario found! Please enter a valid name.");
              this.step = 2;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })
      }
      else if (this.step === 3) {
        this.tempData.newScenarioName = input;
        this.addBotMessage(
          `Duplicating "${this.tempData.projectScenarioName}" as "${this.tempData.newScenarioName}"...`
        );
        // this.step = 3;
        // this.isLoading = true;
        this.isThinking = true;
        this.loaderBgType = this.appService.loaderColors.pine_green;
        this.fixedLoader = true;
        const param = {
          scenarioId: this.tempData.scenarioId,
          lastDataRefreshDate: this.appService.lastDataRefreshDate,
          newScenarioName: input,
        };
        this.chatbotService.duplicateScenarioById(param).subscribe((data) => {

          if (data.success) {
            this.newScId = data.data[0].ID;
            this.addBotMessage(`Scenario "${this.tempData.newScenarioName}" duplicated successfully.`);
            this.addBotMessage(`Please Click on below link to view the duplicated scenario - `, undefined, `View Scenario`);
            this.appService.scenarioListChanged$.next();
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
          }
          this.step = 1;
          this.loaderBgType = this.appService.loaderColors.pine_green;
          this.fixedLoader = false;
          // this.isLoading = false;
          this.isThinking = false;
          setTimeout(() => { this.resetChat2(); }, 1500);

        });
        this.showInput = false;         
      }
    }
    if (this.currentIntent === 'export scenario data' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenarios would you like to export in ${projectName}?`);
              this.tempData.projectName = projectName;

              this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
                if (data.success && data.data.length > 0) {
      
                  const scenarios = data.data.map(s => ({
                    ScenarioID: s.ScenarioID,
                    projectID: s.ProjectID,
                    ModifiedBy: s.ModifiedBy,
                    ScenarioName: s.ScenarioName,
                    ParentType: s.ParentType
                  }));
                  this.openScenarioModal(scenarios,'export'); // Reuse the modal
                } else {
                  this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                  this.step = 1;
                }
              });
              this.step = 2;
            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      }
    }

    if (this.currentIntent === 'refresh scenario' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenario would you like to Refresh in ${projectName}?`);
              this.tempData.projectName = projectName;
              this.step = 2;
              this.chatbotService.getrefreshscenarios({ projectName: projectName }).subscribe((data) => {
                if (data.success) {
                  if (data.data.length > 0) {
                    console.log(data.data);
                    const scenarios = data.data.map(s => ({
                      name: s.ScenarioName,
                      id: s.ScenarioID
                    }));

                    setTimeout(() => {
                      this.openScenarioModal(scenarios);
                    }, 2000);

                  } else {
                    this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                    this.step = 1;
                  }
                } else {
                  this.addBotMessage("An error has occurred. Please contact the administrator.");
                  this.step = 1;
                }
              }
              );

            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      }
    }

    if (this.currentIntent === 'create scenario' && this.selectedChatbotFlow === 'rule') {
      console.log('[create-scenario debug] step=', this.step, 'input=', input, 'tempData=', this.tempData);

      if (this.step === 1) {
        const answer = input.trim().toLowerCase();
        if (answer.startsWith('y')) {
          this.tempData.isNewProject = false;
          this.addBotMessage("Please enter the project name.");
          this.step = 2;
        } else if (answer.startsWith('n')) {
          this.tempData.isNewProject = true;
          this.addBotMessage("Please enter a name for the new project.");
          this.step = 20;
        } else {
          this.addBotMessage("Please type 'yes' or 'no' -- does this project already exist?");
        }
        this.showInput = true;

      } else if (this.step === 2) {
        // Existing project path: validate it exists, then auto-fill product/channel.
        const projectName = input.trim();
        this.chatbotService.checkProjectName({ projectName }).subscribe({
          next: (data) => {
            if (data.success && data.data.length > 0) {
              this.tempData.projectName = projectName;
              this.chatbotService.getProjectDetails({ projectName }).subscribe({
                next: (detailsData) => {
                  if (detailsData.success && detailsData.data.length > 0) {
                    const projectRow = detailsData.data[0];
                    this.tempData.product = projectRow.BrandName;
                    this.tempData.channel = projectRow.Channel;
                    this.addBotMessage(
                      `Using product "${this.tempData.product}" and channel "${this.tempData.channel}" from project "${projectName}". Please enter a name for the new scenario.`
                    );
                    this.step = 5;
                  } else {
                    this.addBotMessage("Could not read project details. Please contact the administrator.");
                    this.step = 1;
                  }
                },
                error: (err) => {
                  console.error('getProjectDetails error', err);
                  this.addBotMessage("An error occurred looking up the project details. Please contact the administrator.");
                  this.step = 1;
                }
              });
            } else {
              this.addBotMessage("No project found! Please enter a valid existing project name, or start over and choose 'no' to create a new one.");
            }
          },
          error: (err) => {
            console.error('checkProjectName error', err);
            this.addBotMessage("An error occurred checking the project name. Please contact the administrator.");
            this.step = 1;
          }
        });

      } else if (this.step === 20) {
        // New project path
        this.tempData.projectName = input.trim();
        this.isThinking = true;
        this.fetchBrandChannelOptions().subscribe(({ brands }) => {
          this.isThinking = false;
          if (brands.length > 0) {
            this.addBotMessage(
              "Which brand/product is this project for?",
              brands.map((b) => b.brand)
            );
          } else {
            this.addBotMessage("Please enter the brand/product name for this project (e.g. 'SomniGuard Ultra').");
          }
          this.step = 21;
        });

      } else if (this.step === 21) {
        const brand = input.trim();
        this.tempData.product = brand;
        // Brand/Therapy Area is a fixed 1:1 mapping in the master data, so once the brand is
        // known there's nothing meaningful left for the user to type for therapy area -- ask for
        // it separately only when the typed brand isn't one of the known options.
        const matchedBrand = this.brandChannelOptions?.brands.find(
          (b) => b.brand.toLowerCase() === brand.toLowerCase()
        );
        this.tempData.therapyArea = matchedBrand ? matchedBrand.therapyArea : null;

        const channels = this.brandChannelOptions?.channels || [];
        if (channels.length > 0) {
          this.addBotMessage("Which channel is this project for?", channels);
        } else {
          this.addBotMessage("Please enter the channel (e.g. 'Commercial').");
        }
        this.step = 22;

      } else if (this.step === 22) {
        this.tempData.channel = input.trim();

        const projectParams = {
          ProjectName: this.tempData.projectName,
          BrandName: this.tempData.product,
          Channel: this.tempData.channel,
          ChannelGroup: this.tempData.channel,
          IsBookmarked: false,
          CreatedBy: this.appService.loggedInUser?.name || 'CDS_BOT',
          ModifiedBy: this.appService.loggedInUser?.name || 'CDS_BOT',
          Notes: '',
          IsActive: 'Y',
          ProductFamilyFlag: 'Product',
          TherapyArea: this.tempData.therapyArea,
          Team: 'UBC'
        };

        this.chatbotService.createProject(projectParams).subscribe({
          next: (data) => {
            if (data && data.success !== false) {
              this.addBotMessage(`Project "${this.tempData.projectName}" created.`);
              this.addBotMessage("Please enter a name for the new scenario.");
              this.step = 5;
            } else {
              this.addBotMessage("Could not create the project. Please contact the administrator.");
              this.step = 1;
            }
          },
          error: (err) => {
            console.error('createProject error', err);
            this.addBotMessage("An error occurred creating the project. Please contact the administrator.");
            this.step = 1;
          }
        });

      } else if (this.step === 5) {
        const scenarioName = input.trim();
        this.chatbotService.checkScenarioName({ projectName: this.tempData.projectName, scenarioName }).subscribe((data) => {
          if (data.success && data.data.length > 0) {
            this.addBotMessage(`A scenario named "${scenarioName}" already exists in this project. Please enter a different name.`);
          } else {
            this.tempData.scenarioName = scenarioName;
            this.addBotMessage("Please enter the contract start date (YYYY-MM-DD).");
            this.step = 6;
          }
        });

      } else if (this.step === 6) {
        const startDate = input.trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(startDate)) {
          this.addBotMessage("Please enter the contract start date in YYYY-MM-DD format.");
        } else {
          this.tempData.contractStartDate = startDate;
          this.addBotMessage("Please enter the contract end date (YYYY-MM-DD).");
          this.step = 7;
        }

      } else if (this.step === 7) {
        const endDate = input.trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
          this.addBotMessage("Please enter the contract end date in YYYY-MM-DD format.");
        } else {
          this.tempData.contractEndDate = endDate;
          this.isThinking = true;
          // Show the real payer list for this brand/channel up front instead of asking for free
          // text -- the old flow asked first and only showed this same list after a failed guess.
          this.chatbotService.getPayerOptions({
            projectName: this.tempData.projectName,
            product: this.tempData.product,
            channel: this.tempData.channel
          }).subscribe({
            next: (data) => {
              this.isThinking = false;
              const payers: string[] = data.success && Array.isArray(data.data) ? data.data : [];
              this.tempData.payerOptions = payers;
              if (payers.length > 0) {
                this.addBotMessage("Which payer is this for?", payers);
              } else {
                this.addBotMessage("Please enter the payer name (e.g. 'Express Scripts').");
              }
              this.step = 8;
            },
            error: () => {
              this.isThinking = false;
              this.tempData.payerOptions = [];
              this.addBotMessage("Please enter the payer name (e.g. 'Express Scripts').");
              this.step = 8;
            }
          });
        }

      } else if (this.step === 8) {
        const payer = input.trim();
        this.tempData.payer = payer;

        const knownPayers: string[] = this.tempData.payerOptions || [];
        const isKnownPayer = knownPayers.some((p) => p.toLowerCase() === payer.toLowerCase());

        if (isKnownPayer) {
          // Picked from the list already resolved from the same data source
          // debugScenarioSeedData validates against -- no need to validate again before creating.
          this.isThinking = true;
          this.loaderBgType = this.appService.loaderColors.pine_green;
          this.fixedLoader = true;
          this.createEnrichedScenario();
        } else {
          this.isThinking = true;
          this.loaderBgType = this.appService.loaderColors.pine_green;
          this.fixedLoader = true;

          const seedParams = {
            projectName: this.tempData.projectName,
            product: this.tempData.product,
            channel: this.tempData.channel,
            payer,
            contractStartDate: this.tempData.contractStartDate,
            contractEndDate: this.tempData.contractEndDate
          };

          // Fallback for a free-typed payer that wasn't in the list shown (e.g. the list was
          // empty) -- validate it before creating so a typo doesn't surface as an opaque 500.
          this.chatbotService.debugScenarioSeedData(seedParams).subscribe({
            next: () => this.createEnrichedScenario(),
            error: (err) => {
              const availablePayers: string[] = err?.error?.availablePayers;
              this.isThinking = false;
              this.fixedLoader = false;
              if (Array.isArray(availablePayers) && availablePayers.length > 0) {
                const uniquePayers = [...new Set(availablePayers)];
                this.tempData.payerOptions = uniquePayers;
                this.addBotMessage(
                  `"${payer}" isn't a valid payer for ${this.tempData.product} / ${this.tempData.channel}. Please choose one:`,
                  uniquePayers
                );
              } else {
                this.addBotMessage("Could not validate the payer. Please contact the administrator.");
                this.step = 1;
              }
            }
          });
        }
      }
    }

  if (this.selectedChatbotFlow === 'genai' && this.step === 1) {
  if (!this.sessionId) this.initSessionId();
  const responseSessionId = this.sessionId;
  const paramsnew = { query: input, sessionId: this.sessionId, userDetails: {name: this.appService.loggedInUser.name, role :  this.appService.loggedInUser.role} }

  this.isThinking = true;

  // ---------- GENERIC FLOW ----------
  if (this.selectedGenAiSubFlow === 'generic') {
    this.chatbotService.runGenericSearch(paramsnew).subscribe((data) => {

      if (data.success && data.data) {
        let msg: any = data.data;

        if (Array.isArray(msg)) {
          msg = msg
            .map(m => typeof m === 'object' && m.message ? m.message : String(m))
            .join('\n');
        } else if (typeof msg === 'object' && msg.message) {
          msg = msg.message;
        }

        msg = String(msg).replace(/\\n/g, '\n').replace(/\\\\n/g, '\n');
        //msg = String(msg).replace(/\\n/g, '\n').replace(/\\\\n/g, '\n').replace(/"\s*}$/, '').replace(/\s*}$/, '');

       // const html = this.sanitizer.bypassSecurityTrustHtml(marked.parse(msg));
        this.addBotMessage(msg, undefined, undefined, 'aiResponse', responseSessionId);
      }

      this.isThinking = false;
    });
  }

  // ---------- WEB SEARCH FLOW ----------
  else if (this.selectedGenAiSubFlow === 'websearch' && this.userInput.trim()) {
    const query = encodeURIComponent(this.userInput.trim());
    window.open(`https://www.google.com/search?q=${query}`, '_blank');
    this.messages.push({ sender: 'bot', text: "I've opened a web search for you." });
    this.isThinking = false;
  }

  // ---------- NORMAL BOT FLOW ----------
  else {
    this.chatbotService.runUserQueryForbot(paramsnew).subscribe(
      (data) => {

    if (data.data) {
      let msg = data.data;

      if (Array.isArray(msg)) {
        msg = msg.map(m => typeof m === "object" && m.message ? m.message : String(m)).join("\n");
      } else if (typeof msg === "object" && msg.message) {
        msg = msg.message;
      }

       msg = String(msg).replace(/\\\s*\\\s*/g, '\n').replace(/\\n/g, '\n');
      //msg = String(msg).replace(/\\n/g, '\n').replace(/\\\\n/g, '\n').replace(/"\s*}$/, '').replace(/\s*}$/, '');

      this.addBotMessage(msg, undefined, undefined, data.success === false ? undefined : 'aiResponse', responseSessionId);

    }
            else {
              this.addBotMessage("No data found or error occurred.");
            }



            this.isThinking = false;
             this.saveChatToSession();
          },
            (err) => {
              console.error('runUserQueryForbot error', err);
              this.addBotMessage("Error occurred, Please try again.");
              this.isThinking = false; // error path
               this.saveChatToSession();
            });
        }



      }

  // Reset user input
  this.userInput = '';
  this.projectNameSuggestion = '';
}


  openScenario(scenarioID?) {
    // console.log(btoa(this.newScId.toString()));
    this.route.navigate(['/ubc/scenario', btoa(this.newScId.toString())]);

  }

  openScenario_existing(scenarioID?: number, refreshme?: boolean) {
    this.route.navigate(
      ['/ubc/scenario', btoa(scenarioID.toString())],
      { queryParams: { refresh: refreshme ? 'true' : 'false' } }
    );
  }

  // Cached per-session -- the master brand/channel lists don't change within a chat session, so
  // only the first "Create Scenario" -> new project run pays for the round trip.
  private fetchBrandChannelOptions(): Observable<{ channels: string[]; brands: { brand: string; therapyArea: string }[] }> {
    if (this.brandChannelOptions) {
      return of(this.brandChannelOptions);
    }
    return this.chatbotService.getBrandChannelOptions().pipe(
      map((data) => {
        const result = data.success && data.data ? data.data : { channels: [], brands: [] };
        this.brandChannelOptions = result;
        return result;
      }),
      catchError(() => {
        const empty = { channels: [], brands: [] };
        this.brandChannelOptions = empty;
        return of(empty);
      })
    );
  }

  createEnrichedScenario() {
    const params = {
      projectName: this.tempData.projectName,
      scenarioName: this.tempData.scenarioName,
      channel: this.tempData.channel,
      product: this.tempData.product,
      payer: this.tempData.payer,
      contractStartDate: this.tempData.contractStartDate,
      contractEndDate: this.tempData.contractEndDate
    };

    this.addBotMessage(`Creating scenario "${this.tempData.scenarioName}"... this can take up to a couple of minutes.`);

    this.chatbotService.createEnrichedUbcScenario(params).subscribe({
      next: (data) => {
        this.isThinking = false;
        this.fixedLoader = false;
        if (data.success) {
          this.newScId = data.data.scenarioId;
          this.addBotMessage(`Scenario "${this.tempData.scenarioName}" created successfully.`);
          this.addBotMessage(`Please click on below link to view the new scenario - `, undefined, `View Scenario`);
          this.appService.scenarioListChanged$.next();
        } else {
          this.addBotMessage("Could not create the scenario. Please contact the administrator.");
        }
        this.step = 1;
        setTimeout(() => { this.resetChat2(); }, 1500);
      },
      error: () => {
        // A network/timeout error here doesn't mean the create failed server-side -- the pipeline
        // can outlive the response. Check before telling the user to retry.
        this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
          this.isThinking = false;
          this.fixedLoader = false;
          const match = data?.success ? data.data.find(s => s.ScenarioName === this.tempData.scenarioName) : null;
          if (match) {
            this.newScId = match.ScenarioID;
            this.addBotMessage(`Scenario "${this.tempData.scenarioName}" was created (the connection was just slow to respond).`);
            this.addBotMessage(`Please click on below link to view the new scenario - `, undefined, `View Scenario`);
            this.appService.scenarioListChanged$.next();
          } else {
            this.addBotMessage("An error has occurred creating the scenario. Please contact the administrator.");
          }
          this.step = 1;
          setTimeout(() => { this.resetChat2(); }, 1500);
        });
      }
    });
  }

  resetChat2() {
    this.isThinking = false;
    this.projectNameSuggestion = '';
    this.userInput = "";
    this.step = 0;
    this.currentIntent = "";
    this.validationError = '';
    this.tempData = {};
    // this.messages.push({ sender: 'bot', text: '***********************New Conversation**********************' });

    this.addBotMessage('What would you like to do next?', ['Duplicate Scenario', 'Export Scenario Data', 'Delete Scenario', 'Refresh Scenario']);
    this.scrollToBottom();
  }

  resetChat() {
    this.projectNameSuggestion = '';
    this.userInput = "";
    this.step = 0;
    this.currentIntent = "";
    this.validationError = '';
    this.tempData = {};
    if (this.messages.length > 0) {
      this.chatHistory = [...this.messages];
    }
    this.messages = [];
    this.ruleMessages = []; // Clear rule messages

    this.addBotMessage('What would you like to do next?', ['Duplicate Scenario', 'Export Scenario Data', 'Delete Scenario', 'Refresh Scenario']);
    this.scrollToBottom();

    // Save to session storage
    this.saveChatToSession();
  }

  resetgenaiChat() {
    this.projectNameSuggestion = '';
    this.userInput = "";
    this.step = 1;
    this.currentIntent = "";
    this.validationError = '';
    this.tempData = {};
    if (this.messages.length > 0) {
      this.chatHistory = [...this.messages];
    }
    this.messages = [];
    this.genaiMessages = []; // Clear genai messages

    this.addBotMessage('Welcome to Gen AI Based Flow! Ask me anything for creative dynamic calculations.');
    this.scrollToBottom();

    // Save to session storage
    this.saveChatToSession();
  }

  showChatHistory() {
    if (this.chatHistory.length === 0) {
      this.addBotMessage("No previous chat history found.");
    } else {
      // Example: Replay messages (you could customize this further)
      this.addBotMessage("📜 Showing previous chat history:");

      this.chatHistory.forEach(msg => {
        this.messages.push({ ...msg });
      });

      this.scrollToBottom();
    }
  }


  scrollToBottom() {
    // rAF (not an arbitrary setTimeout delay) waits just long enough for the newly-pushed
    // message to be in the DOM, then jumps instantly -- `behavior: 'auto'` is explicit so this
    // can't start fighting a CSS `scroll-behavior: smooth` animation if that ever comes back.
    // Repeated smooth-scroll calls stacking up (one per message) is what made scrolling feel
    // "stuck" after a few messages.
    requestAnimationFrame(() => {
      const element = this.chatWindow?.nativeElement;
      if (element) {
        element.scrollTo({ top: element.scrollHeight, behavior: 'auto' });
      }
    });
  }

  scrollToTop() {
    setTimeout(() => {
      if (this.chatWindow) {
        this.chatWindow.nativeElement.scrollTop = 0;
      }
    });
  }
  trackByMessageIndex(index: number, message: any): number {
    return index;
  }

  isValidFormat(): boolean {
    // Only validate for Step 1 of "Duplicate Scenario"
    // if (this.currentIntent === 'duplicate scenario' && this.step === 1) {
    //   const [scenario, project] = this.userInput.trim().split(',').map((s) => s.trim());
    //   return !!scenario && !!project;
    // }
    // For all other steps, just check that input is not empty
    return this.userInput.trim().length > 0;
  }

  onInputChange(value: string) {
  this.userInput = value;
  this.updateProjectNameSuggestion(value);

  // Show suggestions ONLY when bot is asking for project name
  const isProjectNameStep =
    this.selectedChatbotFlow === 'rule' &&
    (
      (this.step === 1 &&
        (
          this.currentIntent === 'duplicate scenario' ||
          this.currentIntent === 'export scenario data' ||
          this.currentIntent === 'delete scenario' ||
          this.currentIntent === 'refresh scenario'
        )
      ) ||
      (this.currentIntent === 'create scenario' && (this.step === 2 || this.step === 20))
    );

  if (isProjectNameStep && value && this.allProjectNames.length) {
    const lower = value.toLowerCase();
    this.filteredProjectNames = this.allProjectNames
      .filter(name => name.toLowerCase().includes(lower))
      .slice(0, 5);
    this.showDropdown = this.filteredProjectNames.length > 0;
  } else {
    this.filteredProjectNames = [];
    this.showDropdown = false;
  }

  // Validation logic for duplicate scenario intent
  if (this.currentIntent === 'duplicate scenario' && this.step === 1) {
    const [scenario, project] = value.trim().split(',').map(v => v.trim());
    if (!scenario || !project) {
      // this.validationError = 'Please enter in format (Case Sensitive): scenarioName, projectName';
    } else {
      this.validationError = '';
    }
  } else {
    this.validationError = '';
  }
}

updateProjectNameSuggestion(input: string) {
  if (!input) {
    this.projectNameSuggestion = '';
    return;
  }
  const lowerInput = input.toLowerCase();
  const suggestion = this.allProjectNames.find(name =>
    typeof name === 'string' && name.toLowerCase().startsWith(lowerInput)
  );
  if (suggestion && suggestion.length > input.length) {
    // Only show the remaining part (ghosted)
    this.projectNameSuggestion = suggestion.slice(input.length);
  } else {
    this.projectNameSuggestion = '';
  }
}

selectProjectName(name: string) {
  this.userInput = name;
  this.projectNameSuggestion = '';
  this.showDropdown = false;
}


openChatbot() {
  if (this.ruleMessages.length > 0 || this.genaiMessages.length > 0) {
    this.messages =
      this.selectedChatbotFlow === 'rule'
        ? [...this.ruleMessages]
        : [...this.genaiMessages];
  } 
  else {
  this.selectedChatbotFlow = this.appService.resources.IsGenaiChatbotEnabled?.Visible === 'Y' ? 'genai' : 'rule';
  if (this.selectedChatbotFlow === 'genai' && this.genaiMessages.length === 0 && this.messages.length === 0) {
    this.addBotMessage("Welcome to CDS Assistant! Ask me anything for creative dynamic calculations.");
    this.step = 1;
  } else if (this.selectedChatbotFlow === 'rule' && this.ruleMessages.length === 0 && this.messages.length === 0) {
    this.addBotMessage("What would you like to do next?", ["Duplicate Scenario", "Export Scenario Data", "Delete Scenario", "Refresh Scenario"]);
    this.step = 0;
  }

}
  if (this.wasDragged) {
    return;
  }

  const chatbotWidth = 500; // match your SCSS
  const chatbotHeight = 500; // match your SCSS
  const fabHeight = 60; // chatbot-fab height
  const gap = 8; // gap between icon and chat window

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  // Calculate left position (right-aligned, but not out of screen)
  let left = windowWidth - chatbotWidth - 32;
  if (left < 0) left = 8; // clamp to left edge

  // Calculate top position (above icon, but not out of screen)
  let top = windowHeight - chatbotHeight - fabHeight - gap;
  if (top < 0) top = 8; // clamp to top edge

  this.position.left = left;
  this.position.top = top;
  this.isOpen = true;
  this.isMinimized = false;
  // .chat-messages is *ngIf-gated on isOpen, so it's freshly created here and defaults to
  // scrollTop 0 -- without this, opening a chat with existing history shows the oldest messages
  // instead of the latest ones.
  this.scrollToBottom();
}

  closeChatbot() {
    this.isOpen = false;
    this.isMinimized = false;
    this.position.left = null;
    this.position.top = null;
  }

  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
    if (!this.isMinimized) {
      // .chat-messages is *ngIf-gated on !isMinimized too, so restoring from minimized recreates
      // it at scrollTop 0 just like opening does.
      this.scrollToBottom();
    }
  }

  onHeaderMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.dragOffset = {
      x: event.clientX - this.position.left,
      y: event.clientY - this.position.top,
    };
    // Drag tracking runs outside Angular's zone so every mousemove doesn't trigger a full
    // change-detection pass on the whole app -- that's what made dragging feel laggy. The
    // container's position is written straight to the DOM here and only synced back onto
    // `this.position` (inside the zone) once, on drag end.
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('mousemove', this.onDragMove, { passive: true });
      document.addEventListener('mouseup', this.onDragEnd, { passive: true });
    });
  }

  onDragMove = (event: MouseEvent) => {
    if (!this.isDragging) return;

    // Get viewport dimensions
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Chatbot dimensions (should match your SCSS)
    const chatbotWidth = this.isMinimized ? 200 : 500;
    const chatbotHeight = this.isMinimized ? 50 : 500;

    // Clamp left and top so the chatbot stays within the viewport
    let newLeft = event.clientX - this.dragOffset.x;
    let newTop = event.clientY - this.dragOffset.y;

    // Clamp values
    newLeft = Math.max(0, Math.min(newLeft, viewportWidth - chatbotWidth));
    newTop = Math.max(0, Math.min(newTop, viewportHeight - chatbotHeight));

    this.position.left = newLeft;
    this.position.top = newTop;

    const el = this.chatContainerRef?.nativeElement;
    if (el) {
      el.style.left = newLeft + 'px';
      el.style.top = newTop + 'px';
    }
  };

  onDragEnd = () => {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
    // One single change-detection pass to reconcile the [ngStyle] binding with the DOM
    // position we wrote directly during the drag.
    this.ngZone.run(() => {});
  };

  ngOnDestroy() {
    // Clean up listeners if component is destroyed
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);

    if (this.keydownListener) {
      this.keydownListener();
      this.keydownListener = null;
    }

    const el = this.projectNameInputRef?.nativeElement;
    if (el) {
      el.removeEventListener('input', this.onRawInput);
      el.removeEventListener('keydown', this.onRawKeydown);
    }

    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = () => {
    // Chatbot dimensions (should match your SCSS)
    const chatbotWidth = this.isMinimized ? 200 : 500;
    const chatbotHeight = this.isMinimized ? 50 : 500;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Clamp left and top so the chatbot stays within the viewport
    let newLeft = this.position.left;
    let newTop = this.position.top;

    if (newLeft + chatbotWidth > viewportWidth) {
      newLeft = Math.max(0, viewportWidth - chatbotWidth);
    }
    if (newTop + chatbotHeight > viewportHeight) {
      newTop = Math.max(0, viewportHeight - chatbotHeight);
    }

    this.position.left = newLeft;
    this.position.top = newTop;
  };


  openScenarioModal(scenarios: any[], action: 'refresh' | 'delete' | 'export' | 'duplicate' = 'refresh') {
    this.scenarioList = scenarios.map(s => ({ ...s, selected: false }));
    this.allScenarios = [...this.scenarioList];
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.scenarioList.length / this.pageSize);
    this.updatePagedScenarios();
    this.showScenarioModal = true;
    this.selectAllChecked = false;
    this.modalAction = action;
    this.scenarioSearch = '';
  }

  closeScenarioModal() {
    this.showScenarioModal = false;
    this.scenarioSearch = '';
  }
  closeScenarioModaloncancel() {
    this.showScenarioModal = false;
    setTimeout(() => {
      this.addBotMessage(`No selection performed !`);
      this.resetChat2();
      this.scenarioList = [];
    }, 1000);
  }
  // updatePagedScenarios() {
  //   const start = (this.currentPage - 1) * this.pageSize;
  //   this.pagedScenarios = this.scenarioList.slice(start, start + this.pageSize);
  // }
  getEndIndex(): number {
    return Math.min(this.currentPage * this.pageSize, this.scenarioList.length);
  }
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedScenarios();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedScenarios();
    }
  }

  toggleSelectAll() {
    this.scenarioList.forEach(s => s.selected = this.selectAllChecked);
    this.updatePagedScenarios();
  }


  onScenarioCheckChange(selectedIndex: number) {
    if (this.modalAction === 'duplicate') {
      const absoluteIndex = (this.currentPage - 1) * this.pageSize + selectedIndex;
      const wasSelected = this.scenarioList[absoluteIndex].selected;
      this.scenarioList.forEach(s => s.selected = false);
      this.scenarioList[absoluteIndex].selected = !wasSelected;
      this.updatePagedScenarios();
    } else {
      const absoluteIndex = (this.currentPage - 1) * this.pageSize + selectedIndex;
      this.scenarioList[absoluteIndex].selected = !this.scenarioList[absoluteIndex].selected;
      this.selectAllChecked = this.scenarioList.every(s => s.selected);
      this.updatePagedScenarios();
    }
  }
  isScenarioCheckboxDisabled(scenario: any): boolean {
    if (this.modalAction === 'duplicate') {
      const selected = this.scenarioList.find(s => s.selected);
      return !!selected && !scenario.selected;
    }
    return false;
  }
  isDeleteOrRefreshDisabled(): boolean {
    if (this.modalAction === 'duplicate') {
      return this.scenarioList.filter(s => s.selected).length !== 1;
    }
    return !this.scenarioList.some(s => s.selected);
  }

  // async confirmScenarioSelection() {
  //   // Get all selected scenarios
  //   const selectedScenarios = this.scenarioList.filter(s => s.selected);

  //   for (let scenario of selectedScenarios) {
  //     await this.refreshScenarioSequentially(scenario.id);
  //   }
  //   // Optionally close modal or show completion message
  //   this.closeScenarioModal();
  // }

  // refreshScenarioSequentially(scenarioId: number): Promise<void> {
  //   return new Promise(resolve => {
  //     // Call your navigation function
  //     this.openScenario_existing(scenarioId, true);

  //     // Wait for scenario to finish refreshing
  //     // You need a way to know when refresh is done, e.g. listen for an event or use a timeout
  //     // Example with timeout (replace with actual completion logic if available)
  //     setTimeout(() => {
  //       resolve();
  //     }, 3000); // Adjust time as needed
  //   });
  // }

  async confirmScenarioSelection2() {
    const selectedScenarios = this.scenarioList.filter(s => s.selected);
  
    if (selectedScenarios.length === 0) {
      this.addBotMessage(`Please select at least one scenario to ${this.modalAction}.`);
      this.openScenarioModal(this.scenarioList, this.modalAction);
      return;
    }

    this.isThinking = true;
    this.cdRef.detectChanges();
  
    if (this.modalAction === 'delete') {
      let deleteCount = 0;
      for (const scenario of selectedScenarios) {
        // You may need to adjust params based on your API
        const deleteParams = {
          ScenarioID: scenario.ScenarioID || scenario.id,
          projectID: scenario.projectID,
          ModifiedBy: scenario.ModifiedBy,
        };
  
        // Choose API based on scenario type if needed
        let deleteObs;
        if (scenario.ParentType === 'Singleton') {
          deleteObs = this.chatbotService.deletesingletonscenario(deleteParams);
        } else {
          deleteObs = this.chatbotService.masterScenarioDelete(deleteParams);
        }
  
        await new Promise<void>((resolve) => {
          deleteObs.subscribe((data) => {
            if (data.success) {
              deleteCount++;
              this.addBotMessage(`Scenario "${scenario.ScenarioName || scenario.name}" deleted successfully.`);
            } else {
              this.addBotMessage(`Failed to delete scenario "${scenario.ScenarioName || scenario.name}".`);
            }
            resolve();
          });
        });
      }
      this.addBotMessage(`Deleted ${deleteCount} scenario(s).`);
      if (deleteCount > 0) {
        this.appService.scenarioListChanged$.next();
      }
      setTimeout(() => {
        this.resetChat2();
        this.updatePagedScenarios();
      }, 3000);
    } else if (this.modalAction === 'refresh') {

        this.isThinking = true;
        this.cdRef.detectChanges();
        
        const selectedScenarios = this.scenarioList.filter(s => s.selected);
        this.addBotMessage(`Refreshing ${selectedScenarios.length} scenario(s)...`);
        const scenarioIds = selectedScenarios.map(s => s.id);

        this.scenarioRefreshService.setQueue(scenarioIds);

        // Start with the first scenario
        const firstId = this.scenarioRefreshService.getNextScenario();
        if (firstId) {
          this.openScenario_existing(firstId, true);
        }
          setTimeout(() => {
          this.closeScenarioModal();
            }, 300);
    } else if (this.modalAction === 'export') {
      let exportCount = 0;

      for (const scenario of selectedScenarios) {
        const params = {
          scenarioId: scenario.ScenarioID,
          lastDataRefreshDate: this.appService.lastDataRefreshDate,
          resources: this.appService.resources,
          perCapitaData: this.passScenario.getBaseline(),
        };

        try {
          if (scenario.ParentType === 'Singleton') {
            await new Promise<void>((resolve) => {
              this.chatbotService.exportScenarioById(params).subscribe({
                next: (data) => {
                  try {
                    if (data.success) {
                      const dataToExport = data.data;
                      this.exportToExcelService.exportFile(data.scenario, dataToExport, false, 'UBC');
                      exportCount++;
                      this.addBotMessage(`Singleton scenario "${scenario.ScenarioName}" exported successfully.`);
                    } else {
                      this.addBotMessage(`Failed to export singleton scenario "${scenario.ScenarioName}".`);
                    }
                  } catch (err) {
                    this.addBotMessage(`Error exporting singleton scenario "${scenario.ScenarioName}": ${err?.message || err}`);
                  }
                  resolve();
                },
                error: (err) => {
                  this.addBotMessage(`Error exporting singleton scenario "${scenario.ScenarioName}": ${err?.message || 'Unknown error'}`);
                  resolve();
                }
              });
            });
          } else {
            await new Promise<void>((resolve) => {
              this.chatbotService.exportMasterScenarioById(params).subscribe({
                next: (data) => {
                  try {
                    if (data.success) {
                      const masterScenario = { MasterScName: scenario.ScenarioName };
                      const dataToExport = data.data;
                      this.exportToExcelService.exportFile(masterScenario, dataToExport, true, 'UBC');
                      exportCount++;
                      this.addBotMessage(`Parent scenario "${scenario.ScenarioName}" exported successfully.`);
                    } else {
                      this.addBotMessage(`Failed to export parent scenario "${scenario.ScenarioName}".`);
                    }
                  } catch (err) {
                    this.addBotMessage(`Error exporting parent scenario "${scenario.ScenarioName}": ${err?.message || err}`);
                  }
                  resolve();
                },
                error: (err) => {
                  this.addBotMessage(`Error exporting parent scenario "${scenario.ScenarioName}": ${err?.message || 'Unknown error'}`);
                  resolve();
                }
              });
            });
          }
        } catch (err) {
          this.addBotMessage(`Unexpected error exporting "${scenario.ScenarioName}": ${err?.message || err}`);
          // Continue to next scenario even if one fails
        }
  }

  this.addBotMessage(`Exported ${exportCount} scenario(s).`);
  setTimeout(() => {
    this.resetChat2();
    this.updatePagedScenarios();
  }, 3000);
    } else if (this.modalAction === 'duplicate') {
      this.isThinking = false;
      this.tempData.projectScenarioName = selectedScenarios[0].ScenarioName;
      this.tempData.scenarioId = selectedScenarios[0].ScenarioID;
      this.addBotMessage(`Please enter the name for the duplicated scenario`);
      this.showInput = true;
      this.step = 3;

    }

    // this.isThinking = false;
    this.closeScenarioModal();
  }

  getScenarioSelectionLabel(action: string): string {
    switch (action?.toLowerCase()) {
      case 'delete':
        return 'Select scenarios to delete';
      case 'export':
        return 'Select scenarios to export';
      case 'refresh':
        return 'Select scenarios to refresh';
      case 'duplicate':
        return 'Select scenario to duplicate';
      default:
        return 'Select scenarios';
    }
  }


  paginationPages: number[] = [];

  updatePagedScenarios() {
    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedScenarios = this.scenarioList.slice(start, start + this.pageSize);
    this.totalPages = Math.ceil(this.scenarioList.length / this.pageSize);
    this.generatePaginationPages();
  }

  generatePaginationPages() {
  const pages: number[] = [];
  const maxPagesToShow = 3;
  let startPage = Math.max(1, this.currentPage - 1);
  let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }
  this.paginationPages = pages;
}

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePagedScenarios();
  }

  filterScenarios() {
    const search = this.scenarioSearch.trim().toLowerCase();
    if (!search) {
      this.scenarioList = [...this.allScenarios];
    } else {
      this.scenarioList = this.allScenarios.filter(s =>
        (s.ScenarioName || s.name || '').toLowerCase().includes(search)
      );
    }
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.scenarioList.length / this.pageSize);
    this.updatePagedScenarios();
  }


handleScenarioAction() {
  if (this.modalAction === 'delete' || this.modalAction === 'refresh') {
    this.pendingAction = this.modalAction;
    this.showConfirmModal = true;
    this.showScenarioModal = false;      // Hide scenario modal
  } else {
    this.confirmScenarioSelection2();
    this.closeScenarioModal();
  }
}

closeConfirmModal() {
  this.showConfirmModal = false;
  this.showScenarioModal = true;  
  this.pendingAction = null;
}

confirmWarningYes() {
  this.showConfirmModal = false;
  this.pendingAction = null;
  this.confirmScenarioSelection2();
  this.closeScenarioModal();
}

onFabMouseDown(event: MouseEvent) {
  event.preventDefault();

  // If position is not set, calculate it from the button's current position
  if (this.position.left === null || this.position.top === null) {
    const fab = (event.target as HTMLElement).closest('.chatbot-fab') as HTMLElement;
    if (fab) {
      const rect = fab.getBoundingClientRect();
      this.position.left = rect.left;
      this.position.top = rect.top;
    }
  }

  this.isDragging = true;
  this.wasDragged = false; // Reset drag flag
  this.fabDragStart = { x: event.clientX, y: event.clientY };
  this.dragOffset = {
    x: event.clientX - this.position.left,
    y: event.clientY - this.position.top,
  };
  this.fabElementForDrag = (event.target as HTMLElement).closest('.chatbot-fab') as HTMLElement;
  // Same reasoning as the header drag: keep mousemove out of Angular's zone so dragging the
  // floating button doesn't trigger a full change-detection pass per pixel moved.
  this.ngZone.runOutsideAngular(() => {
    document.addEventListener('mousemove', this.onFabDragMove, { passive: true });
    document.addEventListener('mouseup', this.onFabDragEnd, { passive: true });
  });
}

onFabDragMove = (event: MouseEvent) => {
  if (!this.isDragging) return;

  // Ordinary hand tremor between mousedown and mouseup can move the pointer a pixel or two --
  // without a threshold, that got flagged as a drag and openChatbot() silently no-opped on the
  // resulting click, so most single clicks did nothing and it looked like it needed several tries.
  const movedX = Math.abs(event.clientX - this.fabDragStart.x);
  const movedY = Math.abs(event.clientY - this.fabDragStart.y);
  if (!this.wasDragged && Math.max(movedX, movedY) < BotComponent.DRAG_THRESHOLD_PX) {
    return;
  }
  this.wasDragged = true; // Set drag flag if mouse moves past the threshold
  const fabWidth = 60;
  const fabHeight = 60;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  let newLeft = event.clientX - this.dragOffset.x;
  let newTop = event.clientY - this.dragOffset.y;

  newLeft = Math.max(0, Math.min(newLeft, viewportWidth - fabWidth));
  newTop = Math.max(0, Math.min(newTop, viewportHeight - fabHeight));

  this.position.left = newLeft;
  this.position.top = newTop;

  if (this.fabElementForDrag) {
    this.fabElementForDrag.style.left = newLeft + 'px';
    this.fabElementForDrag.style.top = newTop + 'px';
    this.fabElementForDrag.style.position = 'fixed';
  }
};

onFabDragEnd = () => {
  this.isDragging = false;
  setTimeout(() => { this.wasDragged = false; }, 0); // Reset after drag ends
  document.removeEventListener('mousemove', this.onFabDragMove);
  document.removeEventListener('mouseup', this.onFabDragEnd);
  this.fabElementForDrag = null;
  this.ngZone.run(() => {});
};


  clearChatHistory() {
    this.clearChatFromSession();
    this.ruleMessages = [];
    this.genaiMessages = [];
    this.messages = [];
    this.selectedChatbotFlow = 'genai';
    this.selectedGenAiSubFlow = null;
    this.sessionId = null;
  }


}
